export interface IEmploymentForm {
  employmentStatus: string;
  howEmployed: string;
  zeroHoursContract: string;
  typeOfSelfEmployment: string;
}

export enum HowEmployedEnum {
  PERMANENT = 'PERMANENT',
  CONTRACTOR = 'CONTRACTOR',
}

export enum EmploymentStatusEnum {
  EMPLOYEE = 'EMPLOYEE',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  UNEMPLOYED = 'UNEMPLOYED',
  RETIRED = 'RETIRED',
}

export enum TypeOfSelfEmploymentEnum {
  LIMITED_COMPANY_GREATER = 'LIMITED_COMPANY_GREATER',
  LIMITED_COMPANY_BELOW = 'LIMITED_COMPANY_BELOW',
  SOLE_TRADER = 'SOLE_TRADER',
  PARTNERSHIP = 'PARTNERSHIP',
}
